import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Post from "../Components/Post/Post";
import Grid from "@material-ui/core/Grid";
import StaticProfile from "../Components/Profile/StaticProfile";
import PostSkeleton from "../util/PostSkeleton";
import ProfileSkeleton from "../util/ProfileSkeleton";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Navbar from "../Components/Layout/Navbar";
import Divider from "@material-ui/core/Divider";
import Title from "../Components/Layout/Title";

import { connect } from "react-redux";
import { getUserData } from "../redux/actions/dataActions";

const User = ({ match, getUserData, data }) => {
  const [profile, setProfile] = useState(null);
  const [postIdParam, setPostIdParam] = useState(null);

  useEffect(() => {
    const username = match.params.username;
    const postId = match.params.postId;

    if (postId) setPostIdParam(postId);
    console.log(username);
    getUserData(username);
    axios
      .get(`/user/${username}`)
      .then((res) => {
        setProfile(res.data.user);
      })
      .catch((err) => console.log(err));
  }, [getUserData, match.params.postId, match.params.username]);

  const { posts, loading } = data;

  const postMarkup = loading ? (
    <PostSkeleton />
  ) : posts === null ? (
    <p>No posts from this user</p>
  ) : !postIdParam ? (
    posts.map((post) => <Post key={post.postId} post={post} />)
  ) : (
    posts.map((post) => {
      if (post.postId !== postIdParam)
        return <Post key={post.postId} post={post} />;
      else return <Post key={post.postId} post={post} openDialog />;
    })
  );

  return (
    <Grid container xs={12} justify="center" disableGutters>
      <Navbar />
      <Grid
        container
        style={{ marginTop: "4rem" }}
        spacing={2}
        xs={12}
        justify="center"
      >
        <Grid item xs={12} md={4}>
          {profile === null ? (
            <ProfileSkeleton />
          ) : (
            <StaticProfile profile={profile} />
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          <Title label="Posts" />
          {postMarkup}
        </Grid>
      </Grid>
    </Grid>
  );
};

User.propTypes = {
  getUserData: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps, { getUserData })(User);

// Add Edit profile pic and edit profile icon
